import * as React from 'react';
import {ReactNode, useState} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import './styles.scss';
interface AppSimpleAccordionProps {
  header: ReactNode;
  content: ReactNode;
  headerClasses?: string;
  contentClasses?: string;
  showIcon?: boolean;
  buStyles: any;
  openByDefault?: boolean;
  onMouseOverIcon?: () => void;
}

const AppSimpleAccordion = ({
  header,
  content,
  headerClasses,
  contentClasses,
  showIcon = true,
  buStyles,
  openByDefault = false,
  onMouseOverIcon,
}: AppSimpleAccordionProps) => {
  const primaryColor = buStyles.primaryColor || '#00DFE9';

  const [open, setOpen] = useState(openByDefault);
  const toggleShowContent = () => setOpen(!open);

  return (
    <>
      <div
        className={`${headerClasses} app-simple-accordion-header`}
        onClick={toggleShowContent}>
        {header}
        {content && showIcon && (
          <div
            className="app-simple-accordion-icon-container"
            onMouseEnter={() => onMouseOverIcon && onMouseOverIcon()}>
            <Icon
              color={primaryColor}
              name={
                open
                  ? Icons.CHEVRON_WITH_CIRCLE_UP
                  : Icons.CHEVRON_WITH_CIRCLE_DOWN
              }
              width="20"
              height="20"
              strokeWidth="0.8"
            />
          </div>
        )}
      </div>
      {content && open && <div className={contentClasses}>{content}</div>}
    </>
  );
};

const mapStateToProps = ({globalStyles}: any) => ({
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(AppSimpleAccordion));
